module.exports = __webpack_public_path__ + "static/images/icon-map.03c3d7d9a480a2200436f33393964b75.svg";